import { createContext, useContext } from 'react'

interface WebPlayContextType {
  storageId: string
}

export const WebPlayContext = createContext<WebPlayContextType | undefined>(undefined)

/**
 * Hook to access the WebPlay context
 * Must be used within a WebPlayContext.Provider
 */
export function useWebPlayContext() {
  const context = useContext(WebPlayContext)
  if (!context) {
    throw new Error('useWebPlayContext must be used within a WebPlayContext.Provider')
  }
  return context
}

export default WebPlayContext
